import {TranslationObject} from '@colonist/i18n'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {ViewPopupOptions} from '../../../shared/scripts/ui_popup/ViewPopupOptions'
import {createDivIn, createIFrameIn} from '../../../shared/scripts/ui_utils/DomUtils'
import {UIMSingletonPageController} from '../ui_fullscreen/UIMSingletonPageController'
import {UIMViewPageNavigationWarningPopup} from './UIMViewPageNavigationWarningPopup'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils'

export class UIMViewProfilePopup extends ViewPopup {
    private readonly username: string
    private iframe: HTMLIFrameElement | undefined

    constructor(username: string) {
        const title: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: `${username}'s Profile`}}
        const body: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: ''}}

        const checkAction: () => void = () => undefined
        const xAction: () => void = () => undefined
        const canCancel: boolean = true
        const options: ViewPopupOptions = {
            showXButton: false,
            showCheckButton: false,
            showXonHeader: true,
        }

        super(title, body, checkAction, xAction, canCancel, options)
        this.username = username

        this.contentContainer.style.width = '90vw'
        this.contentContainer.style.height = '90vh'

        this.body.classList.add('no-padding')
        this.body.classList.add('iframe-container')
        this.footer.classList.add('no-padding')

        this.createIframe()
    }

    private createIframe() {
        this.body.removeChild(this.body.children[0])
        this.show()
        this.iframe = createIFrameIn(this.body, '80vh', '90vw', `/profile/${encodeURIComponent(this.username)}`)
        this.showLoading()
        this.iframe.onload = () => {
            if(!this.iframe) return
            UIMViewProfilePopup.updateIFrameStyles(this.iframe)
            UIMViewProfilePopup.updateGiftingButton(this.iframe)
            UIMViewProfilePopup.updatePageNavigationListener(this.iframe)
            this.hideLoading()
        }
    }

    private showLoading() {
        const loadingElement = createDivIn(this.body, 'loading-spinner')
        loadingElement.style.display = 'block'
        if(this.iframe) this.iframe.style.display = 'none'
    }

    private hideLoading() {
        const loadingElement = this.body.querySelector('.loading-spinner')
        if(loadingElement) loadingElement.remove()
        if(this.iframe) this.iframe.style.display = 'block'
    }

    static updateIFrameStyles(iframe: HTMLIFrameElement) {
        const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document
        if(!iframeDocument) return

        const headerElement = iframeDocument.getElementById('page_header')
        const searchElement = iframeDocument.getElementById('component_search_form_profile_search')
        const notificationElement = iframeDocument.getElementById('top-notification-container')
        const profilePageElement = iframeDocument.getElementById('profile_page_main_container')
        const searchButtonElement = iframeDocument.getElementById('m-profile-search-button')

        if(headerElement) headerElement.style.display = 'none'
        if(searchElement) searchElement.style.display = 'none'
        if(notificationElement) notificationElement.style.display = 'none'
        if(profilePageElement) profilePageElement.classList.add('profile-popup')
        if(searchButtonElement) searchButtonElement.style.display = 'none'
    }

    static updateGiftingButton(iframe: HTMLIFrameElement) {
        const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document
        if(!iframeDocument) return

        setTimeout(() => {
            const giftButton = iframeDocument.getElementById('profile_dropdown_gift_membership')
            if(!giftButton) return

            giftButton.onclick = (e: MouseEvent) => {
                e.preventDefault()
                e.stopPropagation()

                const pathSegments = iframeDocument.location.pathname.split('/')
                const username = pathSegments[pathSegments.length - 1]

                new UIMViewPageNavigationWarningPopup(() => navigateToPage(`/mobile/store?username=${username}#gift`))
            }
        }, 1000)
    }

    static updatePageNavigationListener(iframe: HTMLIFrameElement) {
        const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document
        if(!iframeDocument) return

        iframeDocument.addEventListener('click', UIMSingletonPageController.routesListener, true)
    }
}
